<template>
  <div class="data-wrap">
    <div class="data-tab" v-if="gameIdx > 0">
      <div class="tab-item" v-for="(i, idx) in gameIdx" :class="{ 'active': idx === activeGameIdx }" :key="`${i}-${idx}`"
        @click="changeTab(idx)">第{{ i | numToCN }}局</div>
    </div>
    <div class="data-content">
      <template v-if="!isDataLoading && activeGameInfo && activeGameInfo.home && activeGameInfo.home.team">
        <div class="info">
          <div class="info-wrap" :style="{ backgroundImage: `url(${activeGameInfo.map_apply.cover})` }">
            <div class="kill">
              <div class="home">
                <div class="team" :class="[isHomeRed ? 'home-red' : 'home-blue']">
                  <img :src="activeGameInfo.home.team.team_logo" @error="onCsgoTeamLogoError" alt="" />
                  <img class="success-icon" v-if="activeGameInfo.home.team.is_win"
                    src="../../../assets/images/gaming/success-icon.png" alt="">
                </div>
                <span>{{ activeGameInfo.home.team.team_name }}</span>
              </div>
              <div class="score-wrap">
                <div class="map-name">
                  <p class="zh">{{ activeGameInfo.map_apply.name_zh }}</p>
                  <p class="en">{{ activeGameInfo.map_apply.name_en }}</p>
                </div>
                <div class="score-num">
                  <div class="kill-count">{{ homeScore }}</div>
                  <img src="../../../assets/images/gaming/duizhan-icon.png" alt="">
                  <div class="kill-count">{{ awayScore }}</div>
                </div>
              </div>
              <div class="away">
                <div class="team" :class="[isHomeRed ? 'away-blue' : 'away-red']">
                  <img :src="activeGameInfo.away.team.team_logo || ''" @error="onCsgoTeamLogoError" alt="" />
                  <img class="success-icon" v-if="activeGameInfo.away.team.is_win"
                    src="../../../assets/images/gaming/success-icon.png" alt="">
                </div>
                <span>{{ activeGameInfo.away.team.team_name || '' }}</span>
              </div>
            </div>
            <div class="event">
              <div class="home">
                <img class="event-img" v-if="activeGameInfo.home.team.is_five"
                  src="../../../assets/images/gaming/five_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.home.team.is_ten"
                  src="../../../assets/images/gaming/ten_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.home.team.one_pistol"
                  src="../../../assets/images/gaming/first_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.home.team.sixteen_pistol"
                  src="../../../assets/images/gaming/16_success-pre.png" alt="">
              </div>
              <div class="away">
                <img class="event-img" v-if="activeGameInfo.away.team.is_five"
                  src="../../../assets/images/gaming/five_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.away.team.is_ten"
                  src="../../../assets/images/gaming/ten_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.away.team.one_pistol"
                  src="../../../assets/images/gaming/first_success-pre.png" alt="">
                <img class="event-img" v-if="activeGameInfo.away.team.sixteen_pistol"
                  src="../../../assets/images/gaming/16_success-pre.png" alt="">
              </div>
            </div>
            <div class="score-list">
              <div class="first">上半场 <span :class="[homeFirstSide == 2 ? 'red' : 'blue']">{{ activeGameInfo.home.team &&
      activeGameInfo.home.team.first_half_score || 0 }}</span> : <span
                  :class="[!(homeFirstSide == 2) ? 'red' : 'blue']">{{ activeGameInfo.away.team &&
      activeGameInfo.away.team.first_half_score || 0 }}</span></div>
              <div class="second">下半场 <span :class="[homeSecondSide == 2 ? 'red' : 'blue']">{{ activeGameInfo.home.team
      && activeGameInfo.home.team.second_half_score || 0 }}</span> : <span
                  :class="[!(homeSecondSide == 2) ? 'red' : 'blue']">{{ activeGameInfo.away.team &&
      activeGameInfo.away.team.second_half_score || 0 }}</span></div>
              <div class="overtime" v-if="overTimeScoreCount > 0">加时赛 <span>{{ homeOverTime || 0 }}</span> : <span>{{
      awayOverTime || 0 }}</span></div>
            </div>
          </div>
          <div class="process-wrap">
            <div class="process-list">
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ homeDestroyEnemy }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#007afa' : '#ffad33'" :color="isHomeRed ? '#ffad33' : '#007afa'"
                      :percentage="awayDestroyEnemyRange * 100"></el-progress>
                  </div>
                  <div class="away">{{ awayDestroyEnemy }}</div>
                </div>
                <div class="name">歼灭敌人</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ homeDetonateBomb }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#007afa' : '#ffad33'" :color="isHomeRed ? '#ffad33' : '#007afa'"
                      :percentage="awayDetonateBombRange * 100"></el-progress>
                  </div>
                  <div class="away">{{ awayDetonateBomb }}</div>
                </div>
                <div class="name">引爆炸弹</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ homeDefuseBomb }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#007afa' : '#ffad33'" :color="isHomeRed ? '#ffad33' : '#007afa'"
                      :percentage="awayDefuseBombRange * 100"></el-progress>
                  </div>
                  <div class="away">{{ awayDefuseBomb }}</div>
                </div>
                <div class="name">拆除炸弹</div>
              </div>
              <div class="process-item-wrap">
                <div class="process-item">
                  <div class="home">{{ homeNoTime }}</div>
                  <div class="process-info">
                    <el-progress type="circle" :width="100" stroke-linecap="butt" :show-text="false" :stroke-width="15"
                      :define-back-color="isHomeRed ? '#007afa' : '#ffad33'" :color="isHomeRed ? '#ffad33' : '#007afa'"
                      :percentage="awayNoTimeRange * 100"></el-progress>
                  </div>
                  <div class="away">{{ awayNoTime }}</div>
                </div>
                <div class="name">时间耗尽</div>
              </div>
            </div>
          </div>
        </div>

        <div class="score-event">
          <div class="title">上半场</div>
          <div class="game-limit">
            <div class="name">轮次</div>
            <div class="limit" v-for="i in 15" :key="`limit-${i}`">{{ i }}</div>
          </div>
          <div class="home">
            <div class="name">
              <img :src="activeGameInfo.home.team.team_logo" @error="onCsgoTeamLogoError" alt="" />
            </div>
            <div class="event-item" v-for="(teamEvent, idx) in activeGameInfo.home.team.first_half_mian"
              :key="`first-home-${teamEvent}-${idx}`">
              <img v-if="homeFirstSide == 1 && teamEvent == 2" src="../../../assets/images/gaming/t_killall.png" />
              <img v-if="homeFirstSide == 1 && teamEvent == 3" src="../../../assets/images/gaming/t_bom.png" />
              <img v-if="homeFirstSide == 2 && teamEvent == 1" src="../../../assets/images/gaming/ct_killall.png" />
              <img v-if="homeFirstSide == 2 && teamEvent == 4" src="../../../assets/images/gaming/ct_defuse.png" />
              <img v-if="homeFirstSide == 2 && teamEvent == 5" src="../../../assets/images/gaming/ct_timeout.png" />
            </div>
          </div>
          <div class="away">
            <div class="name">
              <img :src="activeGameInfo.away.team.team_logo" @error="onCsgoTeamLogoError" alt="" />
            </div>
            <div class="event-item" v-for="(teamEvent, idx) in activeGameInfo.away.team.first_half_mian"
              :key="`first-away-${teamEvent}-${idx}`">
              <img v-if="awayFirstSide == 1 && teamEvent == 2" src="../../../assets/images/gaming/t_killall.png" />
              <img v-if="awayFirstSide == 1 && teamEvent == 3" src="../../../assets/images/gaming/t_bom.png" />
              <img v-if="awayFirstSide == 2 && teamEvent == 1" src="../../../assets/images/gaming/ct_killall.png" />
              <img v-if="awayFirstSide == 2 && teamEvent == 4" src="../../../assets/images/gaming/ct_defuse.png" />
              <img v-if="awayFirstSide == 2 && teamEvent == 5" src="../../../assets/images/gaming/ct_timeout.png" />
            </div>
          </div>
          <div class="title">下半场</div>
          <div class="game-limit">
            <div class="name">轮次</div>
            <div class="limit" v-for="i in 15" :key="`limit-${i}`">{{ i }}</div>
          </div>
          <div class="home">
            <div class="name">
              <img :src="activeGameInfo.home.team.team_logo" @error="onCsgoTeamLogoError" alt="" />
            </div>
            <div class="event-item" v-for="(teamEvent, idx) in activeGameInfo.home.team.second_half_mian"
              :key="`second-home-${teamEvent}-${idx}`">
              <img v-if="homeSecondSide == 1 && teamEvent == 2" src="../../../assets/images/gaming/t_killall.png" />
              <img v-if="homeSecondSide == 1 && teamEvent == 3" src="../../../assets/images/gaming/t_bom.png" />
              <img v-if="homeSecondSide == 2 && teamEvent == 1" src="../../../assets/images/gaming/ct_killall.png" />
              <img v-if="homeSecondSide == 2 && teamEvent == 4" src="../../../assets/images/gaming/ct_defuse.png" />
              <img v-if="homeSecondSide == 2 && teamEvent == 5" src="../../../assets/images/gaming/ct_timeout.png" />
            </div>
          </div>
          <div class="away">
            <div class="name">
              <img :src="activeGameInfo.away.team.team_logo" @error="onCsgoTeamLogoError" alt="" />
            </div>
            <div class="event-item" v-for="(teamEvent, idx) in activeGameInfo.away.team.second_half_mian"
              :key="`second-away-${teamEvent}-${idx}`">
              <img v-if="awaySecondSide == 1 && teamEvent == 2" src="../../../assets/images/gaming/t_killall.png" />
              <img v-if="awaySecondSide == 1 && teamEvent == 3" src="../../../assets/images/gaming/t_bom.png" />
              <img v-if="awaySecondSide == 2 && teamEvent == 1" src="../../../assets/images/gaming/ct_killall.png" />
              <img v-if="awaySecondSide == 2 && teamEvent == 4" src="../../../assets/images/gaming/ct_defuse.png" />
              <img v-if="awaySecondSide == 2 && teamEvent == 5" src="../../../assets/images/gaming/ct_timeout.png" />
            </div>
          </div>
        </div>

        <div class="member">
          <div class="member-list">
            <div class="member-title" :class="[isHomeRed ? 'red' : 'blue']">
              <div class="name">{{ activeGameInfo.home.team.team_name }}</div>
              <div class="hero">击杀</div>
              <div class="kda">助攻</div>
              <div class="offered-rate">死亡</div>
              <div class="hit-count">KAST</div>
              <div class="money">ADR</div>
              <div class="damage-count">K-D DIFF</div>
              <div class="damage-taken-count">F-K DIFF</div>
              <div class="prod">Rating</div>
            </div>
            <template v-for="(player, idx) in activeGameInfo.home.player">
              <GameMemberItem :key="`${player.player_id}-${idx}`" :player="player" :coverInfo="coverInfo" />
            </template>
          </div>

          <div class="member-list">
            <div class="member-title" :class="[!isHomeRed ? 'red' : 'blue']">
              <div class="name">{{ activeGameInfo.away.team.team_name }}</div>
              <div class="hero">击杀</div>
              <div class="kda">助攻</div>
              <div class="offered-rate">死亡</div>
              <div class="hit-count">KAST</div>
              <div class="money">ADR</div>
              <div class="damage-count">K-D DIFF</div>
              <div class="damage-taken-count">F-K DIFF</div>
              <div class="prod">Rating</div>
            </div>
            <template v-for="(player, idx) in activeGameInfo.away.player">
              <GameMemberItem :key="`${player.player_id}-${idx}`" :player="player" :coverInfo="coverInfo" />
            </template>
          </div>
        </div>
      </template>
      <div class="page-loading" v-if="isDataLoading">
        <div class="img-wrap">
          <img src="//static.fly2a.com/static/image/f-jiazai-min.png" />
        </div>
      </div>
      <div class="empty-page"
        v-if="!(activeGameInfo && activeGameInfo.home && activeGameInfo.home.team) && !isDataLoading">
        <img src="../../../assets/images/gaming/empty-game.png" alt="">
        <p>暂无数据！</p>
      </div>
    </div>
  </div>
</template>

<script>
import GameMemberItem from './gameMemberItem.vue'
import MoneyChart from './moneyChart.vue'

export default {
  name: 'GameData',
  components: {
    GameMemberItem, MoneyChart
  },
  props: {
    coverInfo: {
      type: Object
    },
    gameInfo: {
      type: Object
    },
    activeGameIdx: {
      type: Number
    },
    moreGameData: {
      type: Object
    },
    moreCoverInfo: {
      type: Object
    },
    diffInfo: {
      type: Object
    },
    moreDiffInfo: {
      type: Object
    },
    isDataLoading: {
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  computed: {
    homeName() {
      return this.coverInfo.home_team_name
    },
    awayName() {
      return this.coverInfo.away_team_name
    },
    gameIdx() {
      return this.coverInfo.game_count
    },
    isLastIdx() {
      return this.coverInfo.game_count === (this.activeGameIdx + 1)
    },
    activeCoverInfo() {
      if (this.isLastIdx) {
        return this.coverInfo
      } else {
        return this.moreCoverInfo[this.activeGameIdx]
      }
    },
    activeGameInfo() {
      if (this.isLastIdx) {
        return this.gameInfo
      } else {
        return this.moreGameData[this.activeGameIdx]
      }
    },
    isHomeRed() {
      if (this.isLastIdx) {
        return this.gameInfo.home.team.first_side == 2
      } else {
        return this.activeGameInfo.home.team.first_side == 2
      }
    },
    homeFirstSide() {
      return this.activeGameInfo.home.team.first_side || 0
    },
    homeSecondSide() {
      return this.activeGameInfo.home.team.second_side || 0
    },
    awayFirstSide() {
      return this.activeGameInfo.away.team.first_side || 0
    },
    awaySecondSide() {
      return this.activeGameInfo.away.team.second_side || 0
    },
    homeScore() {
      const count = this.activeGameInfo.home.team && (this.activeGameInfo.home.team.first_half_score + this.activeGameInfo.home.team.second_half_score + (this.activeGameInfo.home.team.overtime_score || 0)) || 0
      return count - 0
    },
    awayScore() {
      const count = this.activeGameInfo.away.team && (this.activeGameInfo.away.team.first_half_score + this.activeGameInfo.away.team.second_half_score + (this.activeGameInfo.away.team.overtime_score || 0)) || 0
      return count - 0
    },
    homeNoTime() {
      const money = this.activeGameInfo.home.team && this.activeGameInfo.home.team.no_time || 0
      return money - 0
    },
    awayNoTime() {
      const money = this.activeGameInfo.away.team && this.activeGameInfo.away.team.no_time || 0
      return money - 0
    },
    noTimeCount() {
      const homeCount = this.homeNoTime || 0
      const awayCount = this.awayNoTime || 0
      return homeCount + awayCount
    },
    homeNoTimeRange() {
      if (this.noTimeCount < 1) {
        return 0.5
      }
      return this.homeNoTime / this.noTimeCount
    },
    awayNoTimeRange() {
      if (this.noTimeCount < 1) {
        return 0.5
      }
      return this.awayNoTime / this.noTimeCount
    },
    homeDestroyEnemy() {
      const count = this.activeGameInfo.home.team && this.activeGameInfo.home.team.destroy_enemy || 0
      return count - 0
    },
    awayDestroyEnemy() {
      const count = this.activeGameInfo.away.team && this.activeGameInfo.away.team.destroy_enemy || 0
      return count - 0
    },
    destroyEnemyCount() {
      const homeCount = this.homeDestroyEnemy
      const awayCount = this.awayDestroyEnemy
      return homeCount + awayCount
    },
    homeDestroyEnemyRange() {
      if (this.destroyEnemyCount < 1) {
        return 0.5
      }
      return this.homeDestroyEnemy / this.destroyEnemyCount
    },
    awayDestroyEnemyRange() {
      if (this.destroyEnemyCount < 1) {
        return 0.5
      }
      return this.awayDestroyEnemy / this.destroyEnemyCount
    },
    homeDetonateBomb() {
      const count = this.activeGameInfo.home.team && this.activeGameInfo.home.team.detonate_bomb || 0
      return count - 0
    },
    awayDetonateBomb() {
      const count = this.activeGameInfo.away.team && this.activeGameInfo.away.team.detonate_bomb || 0
      return count - 0
    },
    detonateBombCount() {
      const homeCount = this.homeDetonateBomb || 0
      const awayCount = this.awayDetonateBomb || 0
      return homeCount + awayCount
    },
    homeDetonateBombRange() {
      if (this.detonateBombCount < 1) {
        return 0.5
      }
      return this.homeDetonateBomb / this.detonateBombCount
    },
    awayDetonateBombRange() {
      if (this.detonateBombCount < 1) {
        return 0.5
      }
      return this.awayDetonateBomb / this.detonateBombCount
    },
    homeDefuseBomb() {
      const count = this.activeGameInfo.home.team && this.activeGameInfo.home.team.defuse_bomb || 0
      return count - 0
    },
    awayDefuseBomb() {
      const count = this.activeGameInfo.away.team && this.activeGameInfo.away.team.defuse_bomb || 0
      return count - 0
    },
    defuseBombCount() {
      return this.homeDefuseBomb + this.awayDefuseBomb
    },
    homeDefuseBombRange() {
      if (this.defuseBombCount < 1) {
        return 0.5
      }
      return this.homeDefuseBomb / this.defuseBombCount
    },
    awayDefuseBombRange() {
      if (this.defuseBombCount < 1) {
        return 0.5
      }
      return this.awayDefuseBomb / this.defuseBombCount
    },
    homeOverTime() {
      const count = this.activeGameInfo.home.team && this.activeGameInfo.home.team.overtime_score || 0
      return count - 0
    },
    awayOverTime() {
      const count = this.activeGameInfo.away.team && this.activeGameInfo.away.team.overtime_score || 0
      return count - 0
    },
    overTimeScoreCount() {
      return this.homeOverTime + this.awayOverTime
    }
  },
  filters: {
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      const second = sec % 60 < 10 ? '0' + sec % 60 : sec % 60
      // 返回结果
      return `${min}:${second}`;
    },
    numToCN(num) {
      // 定义一个数组存储汉字
      const CN_CHARS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      // 定义一个字符串存储结果
      let result = "";
      // 定义一个变量存储位数
      let digit = 0;
      // 使用一个循环遍历数字的每一位
      while (num > 0) {
        // 取出数字的最后一位
        let last = num % 10;
        // 根据位数和值拼接汉字
        if (digit === 0) {
          // 个位
          result = CN_CHARS[last] + result;
        } else if (digit === 1) {
          // 十位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加十和对应的汉字
            result = "十" + CN_CHARS[last] + result;
          }
        } else if (digit === 2) {
          // 百位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加百和对应的汉字
            result = "百" + CN_CHARS[last] + result;
          }
        }
        // 将数字除以10，去掉最后一位
        num = Math.floor(num / 10);
        // 将位数加一
        digit++;
      }
      // 返回结果
      return result;
    },
    formatNumber(num) {
      return num >= 1000 ? (num / 1000).toFixed(1) + 'k' : num;
    }
  },
  methods: {
    changeTab(tab) {
      this.$emit('tabChange', {
        type: 'gameData',
        idx: tab
      })
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.data-wrap {
  .data-tab {
    display: flex;
    height: 66px;
    background: #fff;
    border-radius: 5px;

    .tab-item {
      flex: 1;
      text-align: center;
      line-height: 66px;
      color: #13161B;
      font-size: 22px;
      cursor: pointer;

      &.active {
        color: #E65668;
      }
    }
  }

  .data-content {
    .info {
      padding: 36px 134px 50px;
      background: #fff;
      margin-top: 20px;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);
      border-radius: 4px;

      .info-wrap {
        height: 246px;
        margin: 0 auto;
        padding: 36px 0;
        border-radius: 10px;
        color: #fff;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.65) 100%);
          border-radius: 10px;
        }
      }

      .kill {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        position: relative;
        z-index: 1;

        .score-wrap {
          padding-bottom: 50px;

          .map-name {
            text-align: center;
            margin-bottom: 20px;

            .zh {
              font-size: 18px;
              line-height: 20px;
              margin-bottom: 4px;
            }

            .en {
              font-size: 14px;
              line-height: 16px;
            }
          }

          .score-num {
            display: flex;
            gap: 50px;
            justify-content: center;

            .kill-count {
              font-size: 18px;
              line-height: 34px;
            }

            img {
              width: 34px;
              height: 34px;
            }
          }
        }

        .home,
        .away {
          display: flex;
          flex-direction: column;
          width: 255px;
          align-items: center;

          .team {
            position: relative;
            height: 68px;
            width: 255px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 46px;
              height: 46px;
              display: block;
              padding: 2px;
              border-radius: 4px;
              background-color: #fff;
            }

            .success-icon {
              position: absolute;
              width: 48px;
              height: 28px;
              top: 4px;
              background: none;
              padding: 0;
              border-radius: 0;
            }
          }

          span {
            display: block;
            font-size: 16px;
            text-align: center;
            line-height: 20px;
            white-space: nowrap;
            margin-top: 18px;
            width: 100%;
            font-weight: bold;
          }
        }

        .home-red {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 14px;
            background: #3E89FF;
          }

          background: linear-gradient(-90deg, rgba(47, 103, 191, 0) 0%, rgba(0, 93, 238, 0.65) 100%);
        }

        .home-blue {
          &::before {
            position: absolute;
            content: '';
            left: 0;
            height: 100%;
            top: 0;
            width: 14px;
            background: #FFC242;
          }

          background: linear-gradient(-90deg, rgba(47, 103, 191, 0) 0%, rgba(255, 173, 0, 0.65) 100%);
        }

        .away-red {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 14px;
            background: #3E89FF;
          }

          background: linear-gradient(90deg, rgba(47, 103, 191, 0) 0%, rgba(0, 93, 238, 0.65) 100%);
        }

        .away-blue {
          &::before {
            position: absolute;
            content: '';
            right: 0;
            height: 100%;
            top: 0;
            width: 14px;
            background: #FFC242;
          }

          background: linear-gradient(90deg, rgba(47, 103, 191, 0) 0%, rgba(255, 173, 0, 0.65) 100%);
        }

        .home {
          .success-icon {
            left: 150px;
          }
        }

        .away {
          .success-icon {
            right: 150px;
          }
        }
      }

      .event {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        position: relative;
        z-index: 1;

        .time {
          font-size: 16px;
        }

        .home,
        .away {
          display: flex;
          align-items: center;
          width: 255px;
          justify-content: center;

          .fudai-icon {
            width: 23px;
            height: 23px;
          }

          .money {
            color: #FFA347;
            font-size: 14px;
            margin: 0 5px;
          }

          .event-img {
            width: 30px;
            height: 30px;
          }
        }
      }

      .score-list {
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 66%;
        transform: translate(-50%, -50%);
        display: flex;
        gap: 20px;
        font-size: 14px;
        background: rgba(0, 0, 0, .45);
        border: 1px solid rgba(255, 255, 255, .5);
        padding: 0 8px;
        border-radius: 4px;
        font-size: 14px;
        height: 30px;
        align-items: center;

        >div {
          white-space: nowrap;
        }

        .red {
          color: #48F1FF;
          font-size: 14px;
        }

        .blue {
          color: #FFAD00;
          font-size: 14px;
        }
      }

      .process-wrap {
        align-items: center;
        border-top: 1px solid #ECECEC;
        padding-top: 46px;
        margin-top: 46px;

        .process-list {
          display: flex;
          justify-content: space-between;

          .process-item {
            display: flex;
            align-items: center;
            gap: 10px;

            .process-info {
              width: 100px;
              height: 100px;
            }

            .home,
            .away {
              font-size: 16px;
            }
          }

          .name {
            text-align: center;
            margin-top: 20px;
          }
        }

        .process-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 38px;
          margin-top: 50px;

          .home,
          .away {
            display: flex;
            align-items: center;

            img {
              width: 38px;
              height: 38px;
            }

            .line {
              width: 57px;
              height: 28px;

              &.blue {
                background: linear-gradient(90deg, #F2EEB6 0%, #A06B45 100%);
              }

              &.red {
                background: linear-gradient(90deg, #78EFF9 0%, #7179FF 100%);
              }
            }
          }
        }
      }
    }

    >.money {
      padding: 40px 48px;
      background: #fff;
      margin-top: 20px;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);

      .title {
        text-align: center;
        font-size: 22px;
        line-height: 30px;
        margin-bottom: 30px;
      }
    }

    .score-event {
      margin-top: 20px;
      border-radius: 10px;
      box-shadow: 0px 3px 7px 0px rgba(205, 57, 67, 0.2);
      overflow: hidden;

      .title {
        text-align: center;
        background: #FFF7D0;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
      }

      .game-limit {
        display: flex;
        height: 56px;
        line-height: 56px;
        box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.25);

        .name {
          width: 64px;
          margin-right: 10px;
          text-align: center;
        }

        .limit {
          width: 63px;
          text-align: center;
        }
      }

      .home,
      .away {
        display: flex;
        height: 56px;
        line-height: 56px;
        box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.25);
        background: #fff;

        .name {
          width: 64px;
          margin-right: 10px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 38px;
            height: 38px;
            display: block;
          }
        }

        .event-item {
          width: 63px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 18px;
            height: 18px;
            display: block;
          }
        }
      }
    }

    .member {
      margin-top: 20px;

      .member-list {
        margin-bottom: 20px;

        .name {
          width: 126px;
          margin-right: 10px;
        }

        .hero {
          width: 90px;
        }

        .kda {
          width: 90px;
        }

        .offered-rate {
          width: 76px;
          margin-right: 15px;
        }

        .hit-count {
          width: 76px;
          margin-right: 6px;
        }

        .money {
          width: 76px;
          margin-right: 6px;
        }

        .damage-count {
          width: 76px;
          margin-right: 6px;
        }

        .damage-taken-count {
          width: 76px;
          margin-right: 4px;
        }

        .prod {
          width: 76px;
        }

        .member-title {
          display: flex;
          color: #fff;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          justify-content: space-between;
          padding-right: 20px;

          &.red {
            background: #2E2ECA;
          }

          &.blue {
            background: #B47D4C;
          }

          div {
            height: 54px;
            text-align: center;
            line-height: 54px;
            font-size: 17px;
          }
        }
      }
    }
  }
}

.red-team-color {
  background: linear-gradient(90deg, #78EFF9 0%, #7179FF 100%);
}

.blue-team-color {
  background: linear-gradient(90deg, #F2EEB6 0%, #A06B45 100%);
}

.page-loading {
  min-height: 50vh;
  position: relative;

  .img-wrap {
    position: absolute;
    left: 50%;
    top: 200px;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 150px;
    height: 150px;
    background: rgba(0, 0, 0, .1);
    border-radius: 50%;

    img {
      margin: 55px 0 0 20px;
      animation: jiazai 4s ease-in-out infinite forwards;
    }
  }
}

.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }

  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}
</style>
